
const directive = {};
directive.install = Vue => {
  // 按钮节流
  Vue.directive('throttle', {
    bind(el, binding) {
      let fn = null
      let event = 'click'
      let time = 1500;
      if (typeof binding.value === 'function') {
        fn = binding.value
      } else {
        [fn, event = 'click', time = 1500] = binding.value
      }
      el.addEventListener(event, () => {
        const nowTime = new Date().getTime()
        if (!el.preTime || nowTime - el.preTime > time) {
          el.preTime = nowTime
          fn();
        }
      })
    }
  })
}
export default directive